<template>
  <div class="app-modal" @click="$emit('close')">
    <div class="survey-content modal-content" @click="$event.stopPropagation()">
      <div class="header">
        <img class="arrow-left" src="@/assets/icons/arrow-white-alt.svg" @click="$emit('close')" />
        <span class="title">Obavijesti</span>
        <img class="close" src="@/assets/icons/close.svg" @click="$emit('close')" />
      </div>

      <section>
        <div v-if="notifications && notifications.length">
          <div class="event-for-survey" v-for="event in notifications" v-bind:key="event.id">
            <p class="event-for-survey-name">{{ event.name }}</p>
            <span
              v-for="(eventUser, index) in event.eventUsers"
              v-bind:key="eventUser.userId"
              class="event-for-survey-lecturer"
            >
              {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}
              <span v-if="eventUser.user && eventUser.user.lecturerTitle"> {{ eventUser.user.lecturerTitle }} </span>
              <span v-if="index !== event.eventUsers.length - 1">,</span>
            </span>
            <button class="button" v-on:click="$emit('openSurveyModal', event)" v-if="event.type === 'Lecture'">
              Ocijeni predavanje
            </button>
            <button class="button" v-on:click="$emit('openSurveyModal', event)" v-if="event.type === 'Workshop'">
              Ocijeni radionicu
            </button>
          </div>
        </div>

        <p v-else class="description">Nemaš novih obavijesti.</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationsModal',
  props: ['notifications'],
};
</script>

<style scoped>
.app-modal {
  align-items: flex-start !important;
}

.survey-content {
  margin-top: 90px;
  margin-bottom: 40px;
  width: 33%;
  padding: 40px !important;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 34px;
  align-items: center;
}

.title {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  margin-bottom: 0;
}

.close {
  cursor: pointer;
}

.description {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #ffffffcc;
}

.event-for-survey {
  font-size: 16px;
  line-height: 24px;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid #ffffff1a;
}

.event-for-survey:last-of-type {
  margin-bottom: 8px;
}

.even .event-for-survey-name {
  margin: 0 0 8px 0;
}

.event-for-survey-lecturer {
  font-weight: 400;
  color: #ffffffcc;
}

.button {
  display: block;
  padding: 12px 32px;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  margin-top: 24px;
}

.arrow-left {
  display: none;
}

::-webkit-scrollbar {
  display: none;
}

@media screen and (min-width: 1023px) {
  .button {
    color: #30cec2;
    background-color: transparent;
    padding: 0;
    font-weight: 400;
    text-decoration: underline;
    margin-top: 16px;
    height: auto;
  }
}

@media screen and (max-width: 1024px) {
  .content {
    width: 100%;
    height: 100%;
    border-radius: 0;
    padding-top: 53px;
    margin-top: 0;
  }

  .header {
    justify-content: flex-start;
  }

  .arrow-left {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin-right: 28px;
  }

  .close {
    display: none;
  }
}
</style>
